var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.078,
    height: 22.073,
    viewBox: "0 0 22.078 22.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.967,37.2a5.659,5.659,0,1,0,5.659,5.659A5.65,5.65,0,0,0,10.967,37.2Zm0,9.339a3.679,3.679,0,1,1,3.679-3.679A3.686,3.686,0,0,1,10.967,46.541Zm7.211-9.57a1.32,1.32,0,1,1-1.32-1.32A1.317,1.317,0,0,1,18.177,36.971Zm3.748,1.34a6.532,6.532,0,0,0-1.783-4.625A6.575,6.575,0,0,0,15.518,31.9c-1.822-.1-7.285-.1-9.107,0a6.566,6.566,0,0,0-4.625,1.778A6.554,6.554,0,0,0,0,38.306c-.1,1.822-.1,7.285,0,9.107a6.532,6.532,0,0,0,1.783,4.625,6.584,6.584,0,0,0,4.625,1.783c1.822.1,7.285.1,9.107,0a6.532,6.532,0,0,0,4.625-1.783,6.575,6.575,0,0,0,1.783-4.625C22.029,45.59,22.029,40.133,21.926,38.311ZM19.571,49.368a3.725,3.725,0,0,1-2.1,2.1c-1.453.576-4.9.443-6.506.443s-5.058.128-6.506-.443a3.725,3.725,0,0,1-2.1-2.1c-.576-1.453-.443-4.9-.443-6.506s-.128-5.058.443-6.506a3.725,3.725,0,0,1,2.1-2.1c1.453-.576,4.9-.443,6.506-.443s5.058-.128,6.506.443a3.725,3.725,0,0,1,2.1,2.1c.576,1.453.443,4.9.443,6.506S20.147,47.92,19.571,49.368Z",
    transform: "translate(0.075 -31.825)",
    fill: "#070b0e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8911af216ad33c1de1c295931c9eb60c.svg";
export { ForwardRef as ReactComponent };